<template>
  <div>
    <nav class="navbar navbar-transparent navbar-absolute navbar-login">
      <div class="container" style="width: auto">
        <div class="navbar-header">
          <a href="https://www.qualificationcheck.com" target="_blank">
            <img style="height: 70px; padding: 5px" src="static/img/qc/QC-Logo-2.png" alt="QualificationCheck"/>
          </a>
        </div>
        <div class="navbar-header pull-right">
          <img style="height: 70px; padding-right: 27px" :src="$store.state.partnerLogo" />
        </div>
      </div>
    </nav>

    <div class="wrapper wrapper-full-page" style="min-height: 0px; height: auto">
      <div class="full-page full-page-background login-page">
        <div class="content">
          <div class="container">
            <div class="card">
              <div class="card-header">
                <div class="logo-wrapper">
                  <img src="static/img/qc/logo_main_green.svg" class="content-logo"/>
                </div>
                <h3 class="card-title">
                  <i class="fa fa-exclamation-triangle" aria-hidden="true"/>
                  We're Temporarily Down For Maintenance!
                  <i class="fa fa-exclamation-triangle" aria-hidden="true"/>
                </h3>
              </div>
              <div class="card-content">
                <div class="form-group">
                  We are currently performing scheduled maintenance.
                  <br/>
                  We aim to be back online approximately by
                  <span class="bold">{{this.maintenanceEndDate}}</span>
                  <br/>
                  Please note any existing verifications will progress as usual.
                  <br/>
                  Thank you for your patience.
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer class="footer footer-transparent">
          <div class="container">
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import properties from "src/properties";
  export default {
    data() {
      return {
        maintenanceEndDate: properties.productDowntimeEndDate
      }
    }
  }
</script>
<style scoped>
  .card-title {
    text-align: center;
  }
  .fa {
    margin-left: 10px;
    margin-right: 10px;
    color: darkorange;
  }

  .form-group {
    text-align: center;
  }

  .bold {
    font-weight: 700;
  }

  .content-logo {
    width: 400px
  }

  .logo-wrapper {
    width: max-content;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 20px;
  }
</style>
